import { render, staticRenderFns } from "./MYFooter.vue?vue&type=template&id=b38510c8&scoped=true"
import script from "./MYFooter.vue?vue&type=script&lang=js"
export * from "./MYFooter.vue?vue&type=script&lang=js"
import style0 from "./MYFooter.vue?vue&type=style&index=0&id=b38510c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38510c8",
  null
  
)

export default component.exports